/*
 Copyright (c) 2017 Wells Fargo. 455 Market St., San Francisco, CA 94105 All rights reserved.

 This software is the confidential and proprietary information of Wells Fargo
 bank. ('Confidential Information'). You shall not disclose such Confidential
 Information and shall use it only in accordance with the terms of the license
 agreement you entered into with WellsFargo.

 */
import React from 'react';
import AirplaneIcon from '../../../icons/airplane-icon/AirplaneIcon';
import AlertBellIcon from '../../../icons/alert-bell-icon/AlertBellIcon';
import BarChartIcon from '../../../icons/bar-chart-icon/BarChartIcon';
import BookletIcon from '../../../icons/booklet-icon/BookletIcon';
import BriefcaseIcon from '../../../icons/briefcase-icon/BriefcaseIcon';
import CircledCheckMarkIcon from '../../../icons/circled-check-mark-icon/CircledCheckMarkIcon';
import CompassIcon from '../../../icons/compass-icon/CompassIcon';
import CopiesIcon from '../../../icons/copies-icon/CopiesIcon';
import CreditCardIcon from '../../../icons/credit-card-icon/CreditCardIcon';
import ItemListIcon from '../../../icons/item-list-icon/ItemListIcon';
import MoveMoneyIcon from '../../../icons/move-money-icon/MoveMoneyIcon';
import NavigationMenuHomeIcon from '../../../icons/navigation-menu-home/NavigationMenuHomeIcon';
import NewAccountIcon from '../../../icons/new-account-icon/NewAccountIcon';
import OrderChecksIcon from '../../../icons/order-checks-icon/OrderChecksIcon';
import PhoneIcon from '../../../icons/phone-icon/PhoneIcon';
import PiggyBankIcon from '../../../icons/piggy-bank-icon/PiggyBankIcon';
import PoliciesIcon from '../../../icons/policies-icon/PoliciesIcon';
import ProtectionIcon from '../../../icons/protection-icon/ProtectionIcon';
import ReportFraudIcon from '../../../icons/report-fraud-icon/ReportFraudIcon';
import ShieldIcon from '../../../icons/shield-icon/ShieldIcon';
import StarIcon from '../../../icons/star-icon/StarIcon';
import StatementIcon from '../../../icons/statement-icon/StatementIcon';
import DealsIcon from '../../../icons/deals-icon/DealsIcon';
var icons = {
  'travelplans': /*#__PURE__*/React.createElement(AirplaneIcon, null),
  'manage-alerts': /*#__PURE__*/React.createElement(AlertBellIcon, null),
  'moneymap': /*#__PURE__*/React.createElement(BarChartIcon, null),
  'tours-overviews': /*#__PURE__*/React.createElement(BookletIcon, null),
  'businesssrvs': /*#__PURE__*/React.createElement(BriefcaseIcon, null),
  'requestcopies': /*#__PURE__*/React.createElement(CopiesIcon, null),
  'manage-cards': /*#__PURE__*/React.createElement(CreditCardIcon, null),
  'home': /*#__PURE__*/React.createElement(NavigationMenuHomeIcon, null),
  'manage-accts': /*#__PURE__*/React.createElement(ItemListIcon, null),
  'movemoney': /*#__PURE__*/React.createElement(MoveMoneyIcon, null),
  'newacctsrvs': /*#__PURE__*/React.createElement(NewAccountIcon, null),
  'orderchecks': /*#__PURE__*/React.createElement(OrderChecksIcon, null),
  'contactus': /*#__PURE__*/React.createElement(PhoneIcon, null),
  'budgetsave': /*#__PURE__*/React.createElement(PiggyBankIcon, null),
  'policies': /*#__PURE__*/React.createElement(PoliciesIcon, null),
  'protectaccts': /*#__PURE__*/React.createElement(ProtectionIcon, null),
  'reportfraud': /*#__PURE__*/React.createElement(ReportFraudIcon, null),
  'securitycenter': /*#__PURE__*/React.createElement(ShieldIcon, null),
  'offers': /*#__PURE__*/React.createElement(StarIcon, null),
  'viewstatements': /*#__PURE__*/React.createElement(StatementIcon, null),
  'planning-tools': /*#__PURE__*/React.createElement(CircledCheckMarkIcon, null),
  'creditplan': /*#__PURE__*/React.createElement(CompassIcon, null),
  'my-wf-deals': /*#__PURE__*/React.createElement(DealsIcon, null)
};
export default icons;